import {makeStyles, createStyles, Theme} from "@material-ui/core/styles"
import { GREY_COLOR, PRIMARY_COLOR, WHITE_COLOR } from "~/constants/colors"

export default makeStyles((theme: Theme) =>createStyles({
  stepsContainer:{
    width: '100%',
    padding: '80px 0 128px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: GREY_COLOR.Grey6,
    [theme.breakpoints.down('md')]: {
      padding: '64px 0 112px'
    },
    [theme.breakpoints.down('sm')]: {
      padding: '64px 0 80px'
    }
  },
  stepsTitle: {
    width: 456,
    marginBottom: 16,
    color: PRIMARY_COLOR.Primary1,
    textAlign: 'center',
    [theme.breakpoints.down('xs')]:{
      width: 'calc(100% - 32px)',
      margin: '0 16px 16px'
    }
  },
  stepsSubTitle: {
    color: GREY_COLOR.Grey1,
    width: 415,
    marginBottom: 64,
    textAlign: 'center',
    [theme.breakpoints.down('xs')]:{
      width: 'calc(100% - 32px)',
      margin: '0 16px 64px'
    }
  },
  stepsStartText: {
    color: '#7f8287',
    marginBottom: 16
  },
  itemContainer: {
    width: 640,
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    [theme.breakpoints.down(670)]:{
      width: 590,
    },
    [theme.breakpoints.down('xs')]:{
      width: 'calc(100% - 32px)',
      margin: '0 16px'
    }
  },
  itemContent: {
    width: '100%',
    boxSizing: 'border-box',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08)',
    backgroundColor: WHITE_COLOR,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minHeight: 160,
    [theme.breakpoints.down('xs')]:{
      flexDirection: 'column',
    },
    '& img': {
      width: 96,
      height: 96,
      margin: '0 12px'
    }
  },
  itemHeader: {
    display: 'flex',
    alignItems: 'baseline'
  },
  itemNum: {
    marginTop: 6,
    marginBottom: 4,
    color: GREY_COLOR.Grey4
  },
  itemText: {
    color: GREY_COLOR.Grey1,
    letterSpacing: '0.25px',
    lineHeight: '1.75',
    margin: '38px 24px 38px 48px',
    [theme.breakpoints.down('xs')]:{
      margin: '0px 16px 40px 16px',
    }
  },
  itemStepResult: {
    color: GREY_COLOR.Grey7,
    fontSize: '12px',
    marginLeft: '12px'
  },
  itemLine: {
    height: 54,
    width: 1,
    borderLeft: `1px dashed ${GREY_COLOR.Grey4}`,
    marginBottom: 10,
  },
  itemResult: {
    color: '#74777b',
    marginBottom: 16
  }
}));
